import './App.css';
import React, { useState, useEffect } from "react";
import { baseURl } from "./config";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavBar from './components/NavBar';
import Google from './components/Google';
import Footer from './components/Footer';
import axios from "axios";
import he from "he";
import JobDetailView from './components/JobDetailsPage/JobDetailView';
// Home Page Components
import HeroSection from './components/Home/HeroSection';
import FeatureTwo from './components/Home/FeatureTwo';
import QuoteSection from './components/Home/QuoteSection';
import ValuesSection from './components/Home/ValuesSection';
import MissionSection from './components/Home/MissionSection';
import VisionValuesMission from './components/Home/VisionValuesMission';
import SourcingMethodology from './components/Home/SourcingMethodology';
import FooterBottom from './components/FooterBottom';
import Breadcrumb from './components/Breadcrumb';

// Career Page Components
import Career from './components/Career/Career';
import JobListing from './components/Career/JobListing';
import CompanyCulture from './components/CompanyCulture';
import TalentCommunity from './components/TalentCommunity';
import JobDetailsSection from './components/JobDetailsPage/JobDetailsSection';
import WhyWorkWithAkinex from './components/Career/WhyWorkWithAkinex';
import Commitment from './components/Career/Commitment';

// Products Page Components
import ProductsSection from './components/Products/ProductsSection';
import ProductHeader from './components/Products/ProductHeader';
import ProductDetailPage from './components/Products/ProductDetailPage';
import ProductDetailHeader from './components/Products/ProductDetailHeader';
import ProductSlider from './components/Products/ProductSlider';
import ProductPage from './components/Products/ProductPage';

// Services Page Components
import ServiceHeader from './components/Services/ServiceHeader';
import Services from './components/Services/Services';
import VideoThumbnail from './components/Services/VideoThumbnail';
import ServiceDescription from './components/Services/ServiceDescription';
import ServiceDescriptionHeader from './components/Services/ServiceDescriptionHeader';
import ServiceSlider from './components/Services/ServiceSlider';

// Contact Page Components
import ContactUs from './components/ContactUs/ContactUs';
import ContactDetails from './components/ContactUs/ContactDetails';
import PhotoGallery from './components/Home/PhotoGallery';
import { useDispatch, useSelector } from "react-redux";
import GoogleMapSection from "./components/ContactUs/GoogleMapSection";
import { setProducts, setServices, setGallery,setBanners, setPage, setJobs , setCatDropdown, setsiteSetting} from "./store/slice";
import GalleryDetail from './components/Home/GalleryDetail';
import Loader from "./components/Loader";
import NotFound from "./components/NotFound";

function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const decodeHTML = (html) => (html ? he.decode(html) : "");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [productsRes, servicesRes, galleryRes, bannerRes, pageRes, jobsRes , catDropdown, siteSettingRes] = await Promise.all([
          axios.get(`${baseURl}/api/v1/product`),
          axios.get(`${baseURl}/api/v1/service`),
          axios.get(`${baseURl}/api/v1/gallery`),
          axios.get(`${baseURl}/api/v1/banner`),
          axios.get(`${baseURl}/api/v1/page`),
          axios.get(`${baseURl}/api/v1/career`),
          axios.get(`${baseURl}/api/v1/product/category-dropdown`),
          axios.get(`${baseURl}/api/v1/siteSetting/admin/get`),
        ]);
  
        if (productsRes.data.success) dispatch(setProducts(productsRes.data.data));
        if (servicesRes.data.success) {
          const activeServices = servicesRes.data.data
            .filter((service) => service.isActive)
            .map((service) => ({
              _id: service._id,
              title: decodeHTML(service.title),
              description: decodeHTML(service.description),
              image: `${baseURl}/${service.serviceImage}`,
            }));
          dispatch(setServices(activeServices));
        }
        if (galleryRes.data.success) dispatch(setGallery(galleryRes.data.data));
        if (bannerRes.data.success) dispatch(setBanners(bannerRes.data.data));
        if (pageRes.data.success) dispatch(setPage(pageRes.data));
        if (jobsRes.data.success) dispatch(setJobs(jobsRes.data.data));
        if (catDropdown.data.success) dispatch(setCatDropdown(catDropdown.data.data));
        if (siteSettingRes.data.success) dispatch(setsiteSetting(siteSettingRes.data.data));
      } catch (error) {
        console.error("Error fetching data: ", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, [dispatch]);
  
  if (loading) {
    return <Loader />;
  }

  return (
    <div className='app-container'>
      <Router>
        <Google />
        <NavBar />
        <Routes>
          <Route
            path="/"
            element={
              <div>
                <HeroSection />

                <FeatureTwo />
                {/* <AboutAkinex/> */}
             
              </div>
            }
          />


          

          <Route
            path="/career"
            element={
              <div>
                {/* <Career /> */}
                <WhyWorkWithAkinex />
                {/* <CompanyCulture /> */}
                <Commitment />
                <JobListing />
                {/* <TalentCommunity /> */}
                {/* <JobListing /> */}
             
              </div>
            }
          />

<Route
            path="/product-page"
            element={
              <div>
        <ServiceDescriptionHeader />
        <Breadcrumb />
                <ProductPage/>
             
             
             
              </div>
            }
          />
<Route path="/product-page" element={
  
  <diV>
   <ServiceDescriptionHeader />
     <Breadcrumb />
    <ProductPage />
  </diV>} />
<Route path="/product-page/:categorySlug" element={ <diV>
  <ServiceDescriptionHeader />
     <Breadcrumb />
    <ProductPage />
  </diV>} />
<Route path="/product-page/:categorySlug/:subCategorySlug" element={ <diV>
  <ServiceDescriptionHeader />
     <Breadcrumb />
    <ProductPage />
  </diV>} />
<Route path="/product-page/:categorySlug/:subCategorySlug/:productSlug" element={<ProductDetailPage />} />
<Route path="/product-page/:categorySlug/:productSlug" element={<ProductDetailPage  />} />



          <Route
            path="/products-section"
            element={
              <div>
                <ProductHeader />
                <ProductsSection />
                <ProductSlider />
                
              </div>
            }
          />

          <Route
            path="/about-us-section"
            element={
              
              <div>
                <ServiceDescriptionHeader />
          
              <div id="who-we-are-section">
                <MissionSection />
              </div>
        
              <div id="what-we-do-section">
                <ValuesSection />
              </div>


              <div id="sourcing-methodology">
                <SourcingMethodology />
              </div>
        
              <div id="vision-mission-value-section">
                <VisionValuesMission />
              </div>
        
              {/* <div id="sourcing-partner2">
                <h2>Sourcing Partner</h2>
                <p>Details about sourcing partners go here...</p>
              </div> */}
            </div>
            }
          />

          <Route
            path="/job-description/:id"
            element={
              <div>
                <JobDetailsSection />
              </div>
            }
          />

          <Route
            path="/service-description/:title"
            element={
              <div>
                <ServiceDescriptionHeader />
                <Breadcrumb />
                <ServiceDescription />
              </div>
            }
          />

          <Route
            path="/contact-us"
            element={
              <div>
                <ContactUs />
                <ContactDetails />
                <GoogleMapSection />
              </div>
            }
          />

          <Route
            path="/services"
            element={
              <div>
                <ServiceHeader />
                <Services />
                <VideoThumbnail />
                <ServiceSlider />
              </div>
            }
          />

          <Route
            path="/gallery"
            element={
              <div>
                {/* <GalleryHeader /> */}
           
                <PhotoGallery />
               
              </div>
            }
          />

          <Route
            path="/gallery/:typeSlug"
            element={
              <div>
                        <ServiceDescriptionHeader />
                <GalleryDetail />
               
              </div>
            }
          />

          <Route
            path="/Products/:category/:subCategory/:productName"
            element={
              <div>
                <ProductDetailHeader />
                <Breadcrumb />
                <ProductDetailPage />
                {/* <ProductSlider /> */}
             
              </div>
            }
          />

          <Route
            path="/Products/:category/:productSlug"
            element={
              <div>

                <ProductDetailHeader />
                <Breadcrumb />
                <ProductDetailPage />
                {/* <ProductSlider /> */}
             
              </div>
            }
          />

          <Route
            path="/gallery"
            element={
              <div>


                <PhotoGallery />
               

              </div>
            }
          />

        <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <FooterBottom />
      </Router>
    </div>
  );
}

export default App;
